import {
    array,
    nullable,
    number,
    optional,
    record,
    string,
    type,
} from "superstruct";

import { CartSectionsSchema } from "./CartSectionsSchema";

const CartItemSchema = type({
    id: number(),
    properties: nullable(record(string(), string())),
    quantity: number(),
});

const AddToCartResponseSchema = type({
    items: array(CartItemSchema),
    sections: optional(CartSectionsSchema),
});

export default AddToCartResponseSchema;
